export default __webpack_public_path__ + "static/media/img10.2cc4b7b5.png";